import { Button } from '@/components/common/button'
import { Note } from '@/components/common/note'
import { InfoIcon } from '@/components/icons/info'

const FALLBACK_AVANTIS_URL = 'https://www.avantisfi.com/'

interface Props {
  protocolVaultUrl?: string
}

export const AvantisWithdrawFeeNote = ({ protocolVaultUrl }: Props) => {
  return (
    <Note>
      <div className="flex items-center gap-2">
        <InfoIcon />
        <h6 className="font-bold">Redemption fee</h6>
      </div>
      <p className="text-xs">
        This vault has a fee applied on withdrawals. Redemption fee is dynamic, depending on vault conditions. To learn
        more, visit the{' '}
        <Button variant="default" size="default" className="rounded-full text-xs underline" asChild>
          <a href={protocolVaultUrl ?? FALLBACK_AVANTIS_URL} target="_blank" rel="noreferrer">
            Avantis app
          </a>
        </Button>
        .
      </p>
    </Note>
  )
}
